module.exports = __webpack_public_path__ + "static/media/cube4.ead505e3.gif";